import type { PlaybackAuth } from '@amzn/amp-playback'
import { getAuth } from '@/auth/authRef'

export const webPlaybackAuth: PlaybackAuth = {
    get status$() {
        return getAuth().status
    },
    isSignedIn: () => getAuth().isSignedIn(),
    get authTokenProvider() {
        return getAuth().authTokenProvider
    },
    usesBearer: () => getAuth().usesBearer(),
    signOut: () => getAuth().signOut(),
    get requestCredentials() {
        return getAuth().requestCredentials
    },
    getCsrfHeaders: () => getAuth().getCsrfHeaders?.(),
    getCsrfToken: () => getAuth().getCsrfToken?.(),
    getCustomerId: () => getAuth().getCustomerId?.() ?? null,
    getMontanaCsrf: () => getAuth().getMontanaCsrf?.(),
    getAuthCookieProvider: () => getAuth().getAuthCookieProvider?.(),
}
